import React from "react";

const BGStep3: React.FC<React.SVGProps<SVGSVGElement>> = ({
    width,
    height,
}) => {
    return (
        <svg
        width={width || 296}
        height={height || 193}
        viewBox="0 0 296 193"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2070_1334)">
          <path
            d="M10 171.747C10 175.2 12.9544 178 16.5989 178H277.407C281.051 178 284.006 175.2 284.006 171.747V22.2535C284.006 18.7998 281.051 16 277.407 16H16.5989C12.9544 16 10 18.7998 10 22.2535V171.747Z"
            fill="white"
          />
          <path
            d="M16.599 177.805C13.0684 177.805 10.2063 175.092 10.2063 171.747V22.2539C10.2063 18.9081 13.0684 16.1958 16.599 16.1958H277.407C280.937 16.1958 283.8 18.9081 283.8 22.2539V171.747C283.8 175.092 280.937 177.805 277.407 177.805H16.599Z"
            stroke="#94A3B8"
            strokeWidth="0.5"
          />
          <path d="M57 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M94 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M129 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M165 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M199 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M235 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M22 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
          <path d="M272 160.397V34.04" stroke="#94A3B8" strokeWidth="0.5" />
        </g>
        <g filter="url(#filter1_d_2070_1334)">
          <path
            d="M52 24.3052C52 24.6889 52.097 25 52.2167 25H60.7833C60.903 25 61 24.6889 61 24.3052V7.69483C61 7.31109 60.903 7 60.7833 7H52.2167C52.097 7 52 7.31109 52 7.69483V24.3052Z"
            fill="white"
          />
          <path
            d="M52.2168 24.9785C52.1008 24.9785 52.0068 24.6772 52.0068 24.3054V7.69509C52.0068 7.32334 52.1008 7.02197 52.2168 7.02197H60.7833C60.8993 7.02197 60.9933 7.32334 60.9933 7.69509V24.3054C60.9933 24.6772 60.8993 24.9785 60.7833 24.9785H52.2168Z"
            stroke="#94A3B8"
            strokeWidth="0.5"
          />
        </g>
        <g filter="url(#filter2_d_2070_1334)">
          <path
            d="M230 24.3052C230 24.6889 230.097 25 230.217 25H238.783C238.903 25 239 24.6889 239 24.3052V7.69483C239 7.31109 238.903 7 238.783 7H230.217C230.097 7 230 7.31109 230 7.69483V24.3052Z"
            fill="white"
          />
          <path
            d="M230.217 24.9785C230.101 24.9785 230.007 24.6772 230.007 24.3054V7.69509C230.007 7.32334 230.101 7.02197 230.217 7.02197H238.783C238.899 7.02197 238.993 7.32334 238.993 7.69509V24.3054C238.993 24.6772 238.899 24.9785 238.783 24.9785H230.217Z"
            stroke="#94A3B8"
            strokeWidth="0.5"
          />
        </g>
        <path
          d="M125.63 77C125.728 77 125.822 77.2347 125.891 77.6568C125.961 78.0788 126 78.6539 126 79.25V83.75C126 84.0454 125.991 84.3382 125.972 84.6126C125.953 84.8843 125.926 85.1322 125.891 85.3406C125.857 85.5516 125.816 85.7178 125.771 85.8286C125.727 85.942 125.678 86 125.63 86H96.3705C96.3218 86 96.2737 85.942 96.2286 85.8286C96.1837 85.7178 96.1429 85.5516 96.1085 85.3406C96.0742 85.1322 96.0469 84.8843 96.0281 84.6126C96.0095 84.3382 96 84.0454 96 83.75V79.25C96 78.9546 96.0095 78.6618 96.0281 78.3875C96.0469 78.1158 96.0742 77.8678 96.1085 77.6568C96.1429 77.4484 96.1837 77.2822 96.2286 77.1714C96.2737 77.058 96.3218 77 96.3705 77H125.63Z"
          fill="#EED2FF"
        />
        <path
          d="M89.6296 111C89.7278 111 89.8222 111.263 89.8915 111.732C89.9607 112.201 90 112.837 90 113.5V118.5C90 119.163 89.9607 119.799 89.8915 120.268C89.8222 120.737 89.7278 121 89.6296 121H60.3704C60.2721 121 60.1779 120.737 60.1085 120.268C60.039 119.799 60 119.163 60 118.5V113.5C60 112.837 60.039 112.201 60.1085 111.732C60.1779 111.263 60.2721 111 60.3704 111H89.6296Z"
          fill="#FFCF9C"
        />
        <path
          d="M89.6296 68C89.7278 68 89.8222 68.1449 89.8915 68.4027C89.9607 68.6606 90 69.0103 90 69.375V72.125C90 72.4897 89.9607 72.8394 89.8915 73.0973C89.8222 73.3551 89.7278 73.5 89.6296 73.5H60.3704C60.2721 73.5 60.1779 73.3551 60.1085 73.0973C60.039 72.8394 60 72.4897 60 72.125V69.375C60 69.0103 60.039 68.6606 60.1085 68.4027C60.1779 68.1449 60.2721 68 60.3704 68H89.6296Z"
          fill="#D9D9D9"
        />
        <path
          d="M53.6296 86C53.7278 86 53.8222 86.1449 53.8915 86.4027C53.9607 86.6606 54 87.0103 54 87.375V90.125C54 90.4897 53.9607 90.8394 53.8915 91.0973C53.8222 91.3551 53.7278 91.5 53.6296 91.5H24.3704C24.2721 91.5 24.1779 91.3551 24.1085 91.0973C24.039 90.8394 24 90.4897 24 90.125V87.375C24 87.0103 24.039 86.6606 24.1085 86.4027C24.1779 86.1449 24.2721 86 24.3704 86H53.6296Z"
          fill="#FDB9CB"
        />
        <path
          d="M53.6296 36C53.7278 36 53.8222 36.079 53.8915 36.2197C53.9607 36.3603 54 36.5511 54 36.75V38.25C54 38.4489 53.9607 38.6397 53.8915 38.7803C53.8222 38.921 53.7278 39 53.6296 39H24.3704C24.2721 39 24.1779 38.921 24.1085 38.7803C24.039 38.6397 24 38.4489 24 38.25V36.75C24 36.5511 24.039 36.3603 24.1085 36.2197C24.1779 36.079 24.2721 36 24.3704 36H53.6296Z"
          fill="#CBE3FF"
        />
        <path
          d="M89.6296 36C89.7278 36 89.8222 36.079 89.8915 36.2197C89.9607 36.3603 90 36.5511 90 36.75V38.25C90 38.4489 89.9607 38.6397 89.8915 38.7803C89.8222 38.921 89.7278 39 89.6296 39H60.3704C60.2721 39 60.1779 38.921 60.1085 38.7803C60.039 38.6397 60 38.4489 60 38.25V36.75C60 36.5511 60.039 36.3603 60.1085 36.2197C60.1779 36.079 60.2721 36 60.3704 36H89.6296Z"
          fill="#CBE3FF"
        />
        <path
          d="M125.63 36C125.728 36 125.822 36.079 125.891 36.2197C125.961 36.3603 126 36.5511 126 36.75V38.25C126 38.4489 125.961 38.6397 125.891 38.7803C125.822 38.921 125.728 39 125.63 39H96.3704C96.2721 39 96.1779 38.921 96.1085 38.7803C96.039 38.6397 96 38.4489 96 38.25V36.75C96 36.5511 96.039 36.3603 96.1085 36.2197C96.1779 36.079 96.2721 36 96.3704 36H125.63Z"
          fill="#CBE3FF"
        />
        <path
          d="M161.63 36C161.728 36 161.822 36.079 161.891 36.2197C161.961 36.3603 162 36.5511 162 36.75V38.25C162 38.4489 161.961 38.6397 161.891 38.7803C161.822 38.921 161.728 39 161.63 39H132.37C132.272 39 132.178 38.921 132.108 38.7803C132.039 38.6397 132 38.4489 132 38.25V36.75C132 36.5511 132.039 36.3603 132.108 36.2197C132.178 36.079 132.272 36 132.37 36H161.63Z"
          fill="#CBE3FF"
        />
        <path
          d="M196.63 36C196.728 36 196.822 36.079 196.891 36.2197C196.961 36.3603 197 36.5511 197 36.75V38.25C197 38.4489 196.961 38.6397 196.891 38.7803C196.822 38.921 196.728 39 196.63 39H167.37C167.272 39 167.178 38.921 167.108 38.7803C167.039 38.6397 167 38.4489 167 38.25V36.75C167 36.5511 167.039 36.3603 167.108 36.2197C167.178 36.079 167.272 36 167.37 36H196.63Z"
          fill="#CBE3FF"
        />
        <path
          d="M231.63 36C231.728 36 231.822 36.079 231.891 36.2197C231.961 36.3603 232 36.5511 232 36.75V38.25C232 38.4489 231.961 38.6397 231.891 38.7803C231.822 38.921 231.728 39 231.63 39H202.37C202.272 39 202.178 38.921 202.108 38.7803C202.039 38.6397 202 38.4489 202 38.25V36.75C202 36.5511 202.039 36.3603 202.108 36.2197C202.178 36.079 202.272 36 202.37 36H231.63Z"
          fill="#CBE3FF"
        />
        <path
          d="M268.63 36C268.728 36 268.822 36.079 268.891 36.2197C268.961 36.3603 269 36.5511 269 36.75V38.25C269 38.4489 268.961 38.6397 268.891 38.7803C268.822 38.921 268.728 39 268.63 39H239.37C239.272 39 239.178 38.921 239.108 38.7803C239.039 38.6397 239 38.4489 239 38.25V36.75C239 36.5511 239.039 36.3603 239.108 36.2197C239.178 36.079 239.272 36 239.37 36H268.63Z"
          fill="#CBE3FF"
        />
        <path
          d="M125.63 59C125.728 59 125.822 59.1449 125.891 59.4027C125.961 59.6606 126 60.0103 126 60.375V63.125C126 63.4897 125.961 63.8394 125.891 64.0973C125.822 64.3551 125.728 64.5 125.63 64.5H96.3704C96.2722 64.5 96.1778 64.3551 96.1085 64.0973C96.0387 63.8394 96 63.4897 96 63.125V60.375C96 60.0103 96.0387 59.6606 96.1085 59.4027C96.1778 59.1449 96.2722 59 96.3704 59H125.63Z"
          fill="#D9D9D9"
        />
        <path
          d="M196.63 125C196.728 125 196.822 125.235 196.891 125.657C196.961 126.079 197 126.654 197 127.25V131.75C197 132.045 196.991 132.338 196.972 132.613C196.953 132.884 196.926 133.132 196.891 133.341C196.857 133.552 196.816 133.718 196.771 133.829C196.727 133.942 196.678 134 196.63 134H167.37C167.322 134 167.274 133.942 167.229 133.829C167.184 133.718 167.143 133.552 167.109 133.341C167.074 133.132 167.047 132.884 167.028 132.613C167.01 132.338 167 132.045 167 131.75V127.25C167 126.955 167.01 126.662 167.028 126.387C167.047 126.116 167.074 125.868 167.109 125.657C167.143 125.448 167.184 125.282 167.229 125.171C167.274 125.058 167.322 125 167.37 125H196.63Z"
          fill="#FDB9CB"
        />
        <path
          d="M196.63 104C196.728 104 196.822 104.143 196.891 104.401C196.961 104.659 197 105.011 197 105.375V108.125C197 108.306 196.991 108.484 196.972 108.652C196.953 108.818 196.926 108.97 196.891 109.097C196.857 109.226 196.816 109.328 196.771 109.395C196.727 109.465 196.678 109.5 196.63 109.5H167.37C167.322 109.5 167.274 109.465 167.229 109.395C167.184 109.328 167.143 109.226 167.109 109.097C167.074 108.97 167.047 108.818 167.028 108.652C167.01 108.484 167 108.306 167 108.125V105.375C167 105.194 167.01 105.016 167.028 104.848C167.047 104.682 167.074 104.53 167.109 104.401C167.143 104.274 167.184 104.172 167.229 104.105C167.274 104.035 167.322 104 167.37 104H196.63Z"
          fill="#C6F8B4"
        />
        <path
          d="M89.6297 86C89.728 86 89.8221 86.1435 89.8915 86.4014C89.961 86.6593 90 87.0107 90 87.375V90.125C90 90.3055 89.9905 90.4845 89.9719 90.6521C89.9533 90.8182 89.926 90.9697 89.8915 91.097C89.8571 91.226 89.8163 91.3275 89.7714 91.3952C89.7265 91.4646 89.6782 91.5 89.6297 91.5H60.3705C60.3218 91.5 60.2737 91.4646 60.2286 91.3952C60.1837 91.3275 60.1429 91.226 60.1085 91.097C60.0742 90.9697 60.0469 90.8182 60.0281 90.6521C60.0095 90.4845 60 90.3055 60 90.125V87.375C60 87.1945 60.0095 87.0155 60.0281 86.8479C60.0469 86.6819 60.0742 86.5303 60.1085 86.4014C60.1429 86.274 60.1837 86.1725 60.2286 86.1048C60.2737 86.0354 60.3218 86 60.3705 86H89.6297Z"
          fill="#C6F8B4"
        />
        <path
          d="M53.6297 68C53.728 68 53.8221 68.1435 53.8915 68.4014C53.961 68.6593 54 69.0107 54 69.375V72.125C54 72.3055 53.9905 72.4845 53.9719 72.6521C53.9533 72.8182 53.926 72.9697 53.8915 73.097C53.8571 73.226 53.8163 73.3275 53.7714 73.3952C53.7265 73.4646 53.6782 73.5 53.6297 73.5H24.3705C24.3218 73.5 24.2737 73.4646 24.2286 73.3952C24.1837 73.3275 24.1429 73.226 24.1085 73.097C24.0742 72.9697 24.0469 72.8182 24.0281 72.6521C24.0095 72.4845 24 72.3055 24 72.125V69.375C24 69.1945 24.0095 69.0155 24.0281 68.8479C24.0469 68.6819 24.0742 68.5303 24.1085 68.4014C24.1429 68.274 24.1837 68.1725 24.2286 68.1048C24.2737 68.0354 24.3218 68 24.3705 68H53.6297Z"
          fill="#C6F8B4"
        />
        <path
          d="M53.6297 59C53.728 59 53.8221 59.1956 53.8915 59.5473C53.961 59.899 54 60.3782 54 60.875V64.625C54 64.8712 53.9905 65.1152 53.9719 65.3438C53.9533 65.5702 53.926 65.7768 53.8915 65.9505C53.8571 66.1263 53.8163 66.2648 53.7714 66.3571C53.7265 66.4517 53.6782 66.5 53.6297 66.5H24.3705C24.3218 66.5 24.2737 66.4517 24.2286 66.3571C24.1837 66.2648 24.1429 66.1263 24.1085 65.9505C24.0742 65.7768 24.0469 65.5702 24.0281 65.3438C24.0095 65.1152 24 64.8712 24 64.625V60.875C24 60.6288 24.0095 60.3848 24.0281 60.1562C24.0469 59.9298 24.0742 59.7232 24.1085 59.5473C24.1429 59.3737 24.1837 59.2352 24.2286 59.1429C24.2737 59.0483 24.3218 59 24.3705 59H53.6297Z"
          fill="#EED2FF"
        />
        <path
          d="M268.63 86C268.728 86 268.822 86.3424 268.891 86.9519C268.961 87.5614 269 88.388 269 89.25V95.75C269 96.612 268.961 97.4386 268.891 98.0481C268.822 98.6576 268.728 99 268.63 99H239.37C239.272 99 239.178 98.6576 239.108 98.0481C239.039 97.4386 239 96.612 239 95.75V89.25C239 88.388 239.039 87.5614 239.108 86.9519C239.178 86.3424 239.272 86 239.37 86H268.63Z"
          fill="#FFCF9C"
        />
        <path
          d="M231.63 86C231.728 86 231.822 86.1581 231.891 86.4393C231.961 86.7206 232 87.1021 232 87.5V90.5C232 90.8979 231.961 91.2794 231.891 91.5607C231.822 91.8419 231.728 92 231.63 92H202.37C202.272 92 202.178 91.8419 202.108 91.5607C202.039 91.2794 202 90.8979 202 90.5V87.5C202 87.1021 202.039 86.7206 202.108 86.4393C202.178 86.1581 202.272 86 202.37 86H231.63Z"
          fill="#D9D9D9"
        />
        <path
          d="M268.63 111C268.728 111 268.822 111.261 268.891 111.73C268.961 112.199 269 112.838 269 113.5V118.5C269 118.828 268.991 119.154 268.972 119.458C268.953 119.76 268.926 120.036 268.891 120.267C268.857 120.502 268.816 120.686 268.771 120.81C268.727 120.936 268.678 121 268.63 121H239.37C239.322 121 239.274 120.936 239.229 120.81C239.184 120.686 239.143 120.502 239.109 120.267C239.074 120.036 239.047 119.76 239.028 119.458C239.01 119.154 239 118.828 239 118.5V113.5C239 113.172 239.01 112.846 239.028 112.542C239.047 112.24 239.074 111.964 239.109 111.73C239.143 111.498 239.184 111.314 239.229 111.19C239.274 111.064 239.322 111 239.37 111H268.63Z"
          fill="#EED2FF"
        />
        <path
          d="M231.63 60C231.728 60 231.822 60.1304 231.891 60.3649C231.961 60.5993 232 60.9188 232 61.25V63.75C232 63.9141 231.991 64.0768 231.972 64.2292C231.953 64.3801 231.926 64.5179 231.891 64.6336C231.857 64.7509 231.816 64.8432 231.771 64.9048C231.727 64.9678 231.678 65 231.63 65H202.37C202.322 65 202.274 64.9678 202.229 64.9048C202.184 64.8432 202.143 64.7509 202.109 64.6336C202.074 64.5179 202.047 64.3801 202.028 64.2292C202.01 64.0768 202 63.9141 202 63.75V61.25C202 61.0859 202.01 60.9232 202.028 60.7708C202.047 60.6199 202.074 60.4821 202.109 60.3649C202.143 60.2491 202.184 60.1568 202.229 60.0952C202.274 60.0322 202.322 60 202.37 60H231.63Z"
          fill="#C6F8B4"
        />
        <path
          d="M161.63 121C161.728 121 161.822 121.145 161.891 121.403C161.961 121.661 162 122.01 162 122.375V125.125C162 125.49 161.961 125.839 161.891 126.097C161.822 126.355 161.728 126.5 161.63 126.5H132.37C132.272 126.5 132.178 126.355 132.109 126.097C132.039 125.839 132 125.49 132 125.125V122.375C132 122.01 132.039 121.661 132.109 121.403C132.178 121.145 132.272 121 132.37 121H161.63Z"
          fill="#D9D9D9"
        />
        <path
          d="M161.63 68C161.728 68 161.822 68.1448 161.891 68.4027C161.961 68.6606 162 69.0103 162 69.3749V72.125C162 72.4897 161.961 72.8394 161.891 73.0973C161.822 73.3552 161.728 73.5 161.63 73.5H132.37C132.322 73.5 132.273 73.4644 132.229 73.3954C132.184 73.3262 132.143 73.2249 132.109 73.0973C132.074 72.9695 132.047 72.818 132.028 72.6512C132.009 72.4844 132 72.3057 132 72.125V69.3749C132 69.1943 132.009 69.0156 132.028 68.8488C132.047 68.682 132.074 68.5303 132.109 68.4027C132.143 68.2749 132.184 68.1738 132.229 68.1046C132.273 68.0354 132.322 68 132.37 68H161.63Z"
          fill="#FFCF9C"
        />
        <defs>
          <filter
            id="filter0_d_2070_1334"
            x="0.956299"
            y="9.9458"
            width="294.093"
            height="182.109"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={1} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2070_1334"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2070_1334"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_2070_1334"
            x="42.7568"
            y="0.771973"
            width="29.4866"
            height="38.4565"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={1} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2070_1334"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2070_1334"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_2070_1334"
            x="220.757"
            y="0.771973"
            width="29.4866"
            height="38.4565"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={1} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2070_1334"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2070_1334"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      
    );
};

export default BGStep3;
